import { render, staticRenderFns } from "./stuHome.vue?vue&type=template&id=08836f71&scoped=true&"
import script from "./stuHome.vue?vue&type=script&lang=js&"
export * from "./stuHome.vue?vue&type=script&lang=js&"
import style0 from "./stuHome.vue?vue&type=style&index=0&id=08836f71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08836f71",
  null
  
)

export default component.exports